module.exports = "<p-tree [style]=\"{'width':'250px','height':'500px'}\"  [value]=\"group_list\" selectionMode=\"single\" [(selection)]=\"selected_group\"  (onNodeSelect)=\"onSelectGroup($event)\"></p-tree>\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/sung/WebstormProjects/exafe front/src/app/component/attribute-group-tree/attribute-group-tree.component.html
// module id = ../../../../../src/app/component/attribute-group-tree/attribute-group-tree.component.html
// module chunks = 1